var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.6,
    height: 15.6,
    viewBox: "0 0 19.6 15.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-746.44 -14.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.24,16.18h18a.8.8,0,0,0,0-1.6h-18a.8.8,0,0,0,0,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.24,21.58h-18a.8.8,0,0,0,0,1.6h18a.8.8,0,0,0,0-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.24,28.58h-18a.8.8,0,0,0,0,1.6h18a.8.8,0,0,0,0-1.6Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.b74f527b.svg";
export { ForwardRef as ReactComponent };